import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  FilterJsonExactlyMatching,
  formateDate,
  SortTheList,
} from "../Shared/Utility";
import ConfirmationModal from "../App/ConfirmationModal";
import { useGlobalState } from "../Context/GlobalStateContext";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import { useSearchParams } from "react-router-dom";
import { showErrorMessage } from "../Shared/Toast";

function Rates() {
  const [searchParams] = useSearchParams();
  const selectedMoverID: any = searchParams.get("ID");
  const globalState = useGlobalState();
  const [isAnimation, setIsAnimation] = useState(false);
  const [isAddNew, setIsAddNew] = useState(0);
  const [addEditObject, setAddEditObject] = useState<any>({
    MNVRatesID: 0,
    MNVBaseID: 0,
    Name: "",
    BaseID: 0,
    ObjectTypeID: 0,
    ObjectID: 0,
    Object: null,
    Tier1: null,
    Tier1Add: null,
    Tier1AdminCharges: null,
    Tier2: null,
    Tier2Add: null,
    Tier2AdminCharges: null,
    Tier3: null,
    Tier3Add: null,
    Tier3AdminCharges: null,
    DTPmile: null,
    PTDmile: null,
    DTDmile: null,
    PerStairRate: null,
  });

  const [screenListData, setScreenListData] = useState<any>([]);
  const [screenData, setScreenData] = useState<any>([]);

  useEffect(() => {
    getScreenListData();
    getScreenData();
  }, []);

  function getScreenListData() {
    setIsAnimation(true);
    axiosAuth
      .get(
        AppContext.APIURL +
          "api/MNVRates/MNVRatesGetCompleteDataSetForForeignKeysV2"
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;

          var l_arrTypes = [
            { PID: 1, Name: "Driver" },
            { PID: 2, Name: "Helper" },
          ];
          l_oResponse.push(l_arrTypes);

          var l_arrTiers = [
            { PID: 1, Name: "1" },
            { PID: 2, Name: "2" },
            { PID: 3, Name: "3" },
          ];
          l_oResponse.push(l_arrTiers);

          setScreenListData(l_oResponse);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function getScreenData() {
    setIsAnimation(true);
    axiosAuth
      .get(AppContext.APIURL + "api/MNVRates/MNVRatesGetCompleteGridDataV2")
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data[0];
          l_oResponse = FilterJsonExactlyMatching(
            l_oResponse,
            "IsDeleted",
            false
          );
          if (selectedMoverID && selectedMoverID > 0) {
            l_oResponse = FilterJsonExactlyMatching(
              l_oResponse,
              "MNVRatesID",
              selectedMoverID
            );
          }
          const deepCopy1 = JSON.parse(JSON.stringify(l_oResponse));
          const deepCopy2 = JSON.parse(JSON.stringify(l_oResponse));
          setThisGridListDataWithoutFilters(deepCopy1);
          setThisGridListData(deepCopy2);
          thisGridListDataRef.current = deepCopy2;
          setScreenData(l_oResponse);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function checkValidation() {
    var IsOkay = true;
    if (!addEditObject.MNVBaseID || addEditObject.MNVBaseID == 0) {
      showErrorMessage("Please select Base");
      IsOkay = false;
    } else if (!addEditObject.ObjectTypeID || addEditObject.ObjectTypeID == 0) {
      showErrorMessage("Please select Object Type");
      IsOkay = false;
    } else if (!addEditObject.ObjectID || addEditObject.ObjectID == "") {
      showErrorMessage("Please select Object");
      IsOkay = false;
    }

    if (IsOkay == true) {
      saveScreenData();
    }
  }

  function saveScreenData() {
    setIsAnimation(true);
    let object = {} as any;
    object.MNVRatesID = addEditObject.MNVRatesID;
    object.MNVBaseID = addEditObject.MNVBaseID;
    object.Name = addEditObject.Name;
    object.BaseID = addEditObject.BaseID;
    object.ObjectTypeID = addEditObject.ObjectTypeID;
    object.ObjectID = addEditObject.ObjectID;
    object.Object = addEditObject.Object;
    object.Tier1 = addEditObject.Tier1;
    object.Tier1Add = addEditObject.Tier1Add;
    object.Tier1AdminCharges = addEditObject.Tier1AdminCharges;
    object.Tier2 = addEditObject.Tier2;
    object.Tier2Add = addEditObject.Tier2Add;
    object.Tier2AdminCharges = addEditObject.Tier2AdminCharges;
    object.Tier3 = addEditObject.Tier3;
    object.Tier3Add = addEditObject.Tier3Add;
    object.Tier3AdminCharges = addEditObject.Tier3AdminCharges;
    object.DTPmile = addEditObject.DTPmile;
    object.PTDmile = addEditObject.PTDmile;
    object.DTDmile = addEditObject.DTDmile;
    object.PerStairRate = addEditObject.PerStairRate;

    axiosAuth
      .post(AppContext.APIURL + "api/MNVRates/MNVRatesSave", object)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          if (l_response && l_response[0] && l_response[0].Status == 0) {
            showErrorMessage(l_response[0].Message);
          } else {
            setIsAddNew(0);
            getScreenData();
          }
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function deleteThisRecord(pid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.MNVRatesID = pid;
    axiosAuth
      .post(AppContext.APIURL + "api/MNVRates/MNVRatesDeleteRecord", object)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data;
          getScreenData();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        deleteThisRecord(obj.SelectedID);
      }
    }
    globalState.setConfirmationModalObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({
        x: event.clientX,
        y: event.clientY,
        totalWidth: window.innerWidth,
        totalHeight: window.innerHeight,
      });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = [];
    l_data = [...FilterData];
    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(JSON.stringify(thisGridListDataWithoutFilters));
    setThisGridListData(deepCopy);
    thisGridListDataRef.current = deepCopy;
    setClearFilters(!clearFilters);
  }

  //--States for columnFilter components---///

  const [filters, setFilters] = useState(["", "D"]);

  useLayoutEffect(() => {
    SetSortingImage();
  }, [thisGridListData]);

  function SetSortingImage() {
    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "MNVBaseName")) {
        (
          document.getElementById("imgSort" + "MNVBaseName") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "ObjectType")) {
        (
          document.getElementById("imgSort" + "ObjectType") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "Object")) {
        (
          document.getElementById("imgSort" + "Object") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="10px" height="13px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="10px" height="13px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1]
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}
      <ConfirmationModal
        ConfirmationObject={globalState.ConfirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />

      {thisGridListData && thisGridListData.length > 0 && (
        <ColumnFilterCheckboxList
          DataType={1}
          RefreshFilters={refreshFilters}
          ClearFilters={clearFilters}
          GridData={thisGridListData}
          ColumnName={selectedColumnName}
          ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
          GetFilteredLists={getFilteredLists}
          ReturnAllFilterdLists={{}}
          ClickPosition={clickPosition}
          Orientation={"Center"}
          ColumnOrientation={[{ Name: "Name", Orientation: "Right" }]}
        />
      )}

      {isAddNew == 0 && (
        <>
          <div className="flex-d justify-btw mb-10">
            <span></span>
            <div className="flex-daj flex-gap10">
              <a
                className="link-btn btn-link-m"
                onClick={() => ClearAllFilters()}
              >
                Clear All Filters
              </a>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => {
                    setAddEditObject({
                      MNVRatesID: 0,
                      MNVBaseID: 0,
                      Name: "",
                      BaseID: 0,
                      ObjectTypeID: null,
                      ObjectID: null,
                      Object: null,
                      Tier1: null,
                      Tier1Add: null,
                      Tier1AdminCharges: null,
                      Tier2: null,
                      Tier2Add: null,
                      Tier2AdminCharges: null,
                      Tier3: null,
                      Tier3Add: null,
                      Tier3AdminCharges: null,
                      DTPmile: null,
                      PTDmile: null,
                      DTDmile: null,
                      PerStairRate: null,
                    });
                    setIsAddNew(1);
                  }}
                >
                  Add New
                </a>
              </div>
              <a
                className="btn-primary flex-daj btn-grid"
                title="Export"
                onClick={() => DownloadClientsDataInExcel("tblrates", "Rates")}
              >
                <img src="images/export.svg" width="18" height="18" />
              </a>
            </div>
          </div>
          <div className="flow-auto">
            <table className="reuse-table" id="tblrates">
              <thead>
                <tr>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Base
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "MNVBaseName")
                          }
                          data-function="ShowColumnFilterList"
                          title={"Search By Base"}
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("MNVBaseName")}
                          title={"Sort By Base"}
                        >
                          <span id={"imgSort" + "MNVBaseName"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Object Type
                        <a
                          onClick={(e) => ShowColumnFilterList(e, "ObjectType")}
                          data-function="ShowColumnFilterList"
                          title={"Search By Object Type"}
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("ObjectType")}
                          title={"Sort By Object Type"}
                        >
                          <span id={"imgSort" + "ObjectType"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Object
                        <a
                          onClick={(e) => ShowColumnFilterList(e, "Object")}
                          data-function="ShowColumnFilterList"
                          title={"Search By Object"}
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("Object")}
                          title={"Sort By Object"}
                        >
                          <span id={"imgSort" + "Object"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>Name</th>
                  <th className="td-xxxs">Tier 1</th>
                  <th className="td-xxxs">Tier 1 Add</th>
                  <th className="td-xxxs">Tier 1 Admin Charges</th>
                  <th className="td-xxxs">Tier 2</th>
                  <th className="td-xxxs">Tier 2 Add</th>
                  <th className="td-xxxs">Tier 2 Admin Charges</th>
                  <th className="td-xxxs">Tier 3</th>
                  <th className="td-xxxs">Tier 3 Add</th>
                  <th className="td-xxxs">Tier 3 Admin Charges</th>
                  <th className="td-xxxs">DTP mile</th>
                  <th className="td-xxxs">PTD mile</th>
                  <th className="td-xxxs">DTD mile</th>
                  <th className="td-xxxs">Per Stair Rate</th>
                  {/* <th>Created By Name</th>
                <th>Creation Time stamp</th>
                <th>Created By Username</th>
                <th>Last Updated Time stamp</th>
                <th>Is Deleted</th>
                <th>Last Updated By Name</th>
                <th>Last Updated By Username</th> */}
                  <th className=" td-xxxs">Action</th>
                </tr>
              </thead>
              <tbody>
                {thisGridListData &&
                  thisGridListData.map((item: any, index: any) => (
                    <React.Fragment key={index}>
                      {!item.IsExcluded && (
                        <tr>
                          <td>{item.MNVBaseName}</td>
                          <td>{item.ObjectType}</td>
                          <td>{item.Object}</td>
                          <td>{item.Name}</td>
                          <td className="text-right td-xxxs">{item.Tier1}</td>
                          <td className="text-right td-xxxs">
                            {item.Tier1Add}
                          </td>
                          <td className="text-right td-xxxs">
                            {item.Tier1AdminCharges}
                          </td>
                          <td className="text-right td-xxxs">{item.Tier2}</td>
                          <td className="text-right td-xxxs">
                            {item.Tier2Add}
                          </td>
                          <td className="text-right td-xxxs">
                            {item.Tier2AdminCharges}
                          </td>
                          <td className="text-right td-xxxs">{item.Tier3}</td>
                          <td className="text-right td-xxxs">
                            {item.Tier3Add}
                          </td>
                          <td className="text-right td-xxxs">
                            {item.Tier3AdminCharges}
                          </td>
                          <td className="text-right td-xxxs">{item.DTPmile}</td>
                          <td className="text-right td-xxxs">{item.PTDmile}</td>
                          <td className="text-right td-xxxs">{item.DTDmile}</td>
                          <td className="text-right td-xxxs">
                            {item.PerStairRate}
                          </td>
                          {/* <td>{item.CreatedByName}</td>
                        <td>{formateDate(item.CreationTimestamp)}</td>
                        <td>{item.CreatedByUserName}</td>
                        <td>{formateDate(item.LastUpdatedTimestamp)}</td>
                        <td>{item.IsDeleted == true ? "true" : "false"}</td>
                        <td>{item.LastUpdatedByName}</td>
                        <td>{item.LastUpdatedByUserName}</td> */}
                          <td className=" td-xxxs">
                            <div className="flex-daj gap-10">
                              <a
                                onClick={() => {
                                  setIsAddNew(2);
                                  setAddEditObject({
                                    MNVRatesID: item.MNVRatesID,
                                    MNVBaseID: item.MNVBaseID,
                                    Name: item.Name,
                                    BaseID: item.BaseID,
                                    ObjectTypeID: item.ObjectTypeID,
                                    ObjectID: item.ObjectID,
                                    Object: item.Object,
                                    Tier1: item.Tier1,
                                    Tier1Add: item.Tier1Add,
                                    Tier1AdminCharges: item.Tier1AdminCharges,
                                    Tier2: item.Tier2,
                                    Tier2Add: item.Tier2Add,
                                    Tier2AdminCharges: item.Tier2AdminCharges,
                                    Tier3: item.Tier3,
                                    Tier3Add: item.Tier3Add,
                                    Tier3AdminCharges: item.Tier3AdminCharges,
                                    DTPmile: item.DTPmile,
                                    PTDmile: item.PTDmile,
                                    DTDmile: item.DTDmile,
                                    PerStairRate: item.PerStairRate,
                                    // CreatedByName: item.CreatedByName,
                                    // CreationTimestamp: item.CreationTimestamp,
                                    // CreatedByUserName: item.CreatedByUserName,
                                    // LastUpdatedTimestamp: item.LastUpdatedTimestamp,
                                    // IsDeleted: item.IsDeleted,
                                    // LastUpdatedByName: item.LastUpdatedByName,
                                    // LastUpdatedByUserName: item.LastUpdatedByUserName,
                                  });
                                }}
                              >
                                <img
                                  src="images/edit.svg"
                                  width="18px"
                                  height="18px"
                                  alt="Edit"
                                />
                              </a>
                              <a
                                onClick={() =>
                                  globalState.setConfirmationModalObject({
                                    ShowPopup: true,
                                    Heading: "Alert",
                                    Message:
                                      "Are your sure, you want to delete this record?",
                                    ID: 1,
                                    SelectedID: item.MNVRatesID,
                                    OtherID: 0,
                                  })
                                }
                              >
                                <img
                                  src="images/delete.png"
                                  width="18px"
                                  height="18px"
                                  alt="Delete"
                                />
                              </a>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {(isAddNew == 1 || isAddNew == 2) && (
        <div className="inline-block-d text-center width-100 reuse-border p-all20">
          <>
            <div className="grid-d fr-111 gap-20">
              <div className="field-input grid-d  flex-gap3">
                <span className="font-12 text-left label-color">Base:</span>
                <select
                  className="input-field w-100"
                  value={addEditObject.MNVBaseID}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      MNVBaseID: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Select Base</option>
                  {screenListData[0] &&
                    screenListData[0].map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.PID}>{item.Name}</option>
                      </React.Fragment>
                    ))}
                </select>
              </div>
              <div className="field-input grid-d  flex-gap3">
                <span className="font-12 text-left label-color">
                  Object Type:
                </span>
                <select
                  className="input-field w-100"
                  value={addEditObject.ObjectTypeID}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      ObjectTypeID: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Select Object Type</option>
                  {screenListData[1] &&
                    screenListData[1].map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.PID}>{item.Name}</option>
                      </React.Fragment>
                    ))}
                </select>
              </div>
              <div className="field-input grid-d  flex-gap3">
                <span className="font-12 text-left label-color">Object:</span>
                <select
                  className="input-field w-100"
                  value={addEditObject.ObjectID}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      ObjectID: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Select Object</option>
                  {screenListData[2] &&
                    screenListData[2].map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.PID}>{item.Name}</option>
                      </React.Fragment>
                    ))}
                </select>
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Name:</span>
                <input
                  className="input-field w-100"
                  value={addEditObject.Name}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Name: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Tier 1:</span>
                <input
                  className="input-field w-100"
                  // placeholder="Tier 1:"
                  type="number"
                  value={addEditObject.Tier1}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Tier1: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Tier 1 Additional 30 Minutes Rate:
                </span>
                <input
                  className="input-field w-100"
                  // placeholder="Tier 1 Additional 30 Minutes Rate"
                  type="number"
                  value={addEditObject.Tier1Add}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Tier1Add: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Tier 1 Admin Charges:
                </span>
                <input
                  className="input-field w-100"
                  // placeholder="Tier 1 Admin Charges"
                  type="number"
                  value={addEditObject.Tier1AdminCharges}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Tier1AdminCharges: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Tier 2:</span>
                <input
                  className="input-field w-100"
                  // placeholder="Tier 2"
                  type="number"
                  value={addEditObject.Tier2}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Tier2: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Tier 2 Additional 30 Minutes Rate:
                </span>
                <input
                  className="input-field w-100"
                  // placeholder="Tier 2 Additional 30 Minutes Rate"
                  type="number"
                  value={addEditObject.Tier2Add}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Tier2Add: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Tier 2 Admin Charges:
                </span>
                <input
                  className="input-field w-100"
                  // placeholder="Tier 2 Admin Charges"
                  type="number"
                  value={addEditObject.Tier2AdminCharges}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Tier2AdminCharges: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Tier 3:</span>
                <input
                  className="input-field w-100"
                  // placeholder="Tier 3"
                  type="number"
                  value={addEditObject.Tier3}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Tier3: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Tier 3 Additional 30 Minutes Rate:
                </span>
                <input
                  className="input-field w-100"
                  // placeholder="Tier 3 Additional 30 Minutes Rate"
                  type="number"
                  value={addEditObject.Tier3Add}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Tier3Add: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Tier 3 Admin Charges:
                </span>
                <input
                  className="input-field w-100"
                  // placeholder="Tier 3 Admin Charges"
                  type="number"
                  value={addEditObject.Tier3AdminCharges}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Tier3AdminCharges: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Depo To Pickup mile Rate:
                </span>
                <input
                  className="input-field w-100"
                  // placeholder="Depo To Pickup mile Rate"
                  type="number"
                  value={addEditObject.DTPmile}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      DTPmile: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Pickup To Delivery mile Rate:
                </span>
                <input
                  className="input-field w-100"
                  // placeholder="Pickup To Delivery mile Rate"
                  type="number"
                  value={addEditObject.PTDmile}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      PTDmile: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Delivery To Depo mile Rate:
                </span>
                <input
                  className="input-field w-100"
                  // placeholder="Delivery To Depo mile Rate"
                  type="number"
                  value={addEditObject.DTDmile}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      DTDmile: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Per Stair Rate:
                </span>
                <input
                  className="input-field w-100"
                  // placeholder="Per Stair Rate"
                  type="number"
                  value={addEditObject.PerStairRate}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      PerStairRate: e.target.value,
                    }))
                  }
                />
              </div>
            </div>

            <div className="flex-daj gap-10 mt-20">
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => checkValidation()}
                >
                  {isAddNew == 1 ? "Save" : "Update"}
                </a>
              </div>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setIsAddNew(0)}
                >
                  Cancel
                </a>
              </div>
            </div>
          </>
        </div>
      )}
    </div>
  );
}

export default Rates;
